const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

/**
 * Retrieves the authentication token from localStorage or cookie.
 */
export const getToken = () => {
  return localStorage.getItem('token') || getCookie('token');
};

/**
 * Retrieves the user object from localStorage or cookie.
 */
export const getUser = () => {
  const userStr = localStorage.getItem('user') || getCookie('user');
  if (userStr) {
    try {
      // Decode URL encoded cookie if necessary
      const decoded = decodeURIComponent(userStr);
      return JSON.parse(decoded);
    } catch (e) {
      console.error('Error parsing user data:', e);
      return null;
    }
  }
  return null;
};

/**
 * Saves both the token and user object to localStorage.
 */
export const setAuth = (token, user) => {
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(user));
};

/**
 * Clears all authentication-related data.
 *
 * The `token` cookie is httpOnly by design (so XSS/JS can't read it), which
 * also means client-side JS can never clear it — the document.cookie writes
 * below only ever affected the non-httpOnly `user` cookie. Without a real
 * server-side clear, the httpOnly cookie kept authenticating requests via
 * authMiddleware's cookie fallback for up to its full lifetime after a user
 * "logged out." POST /auth/logout (fire-and-forget — local state is cleared
 * either way, so a network failure here never blocks logout) calls
 * res.clearCookie() server-side to actually end that session.
 */
export const clearAuth = () => {
  // H3: the session is revoked SERVER-SIDE by POST /auth/logout, which needs the credential. The auth cookie is never
  // stored for the API origin (cross-origin XHR without credentials), so the Bearer token is the only thing that
  // identifies the session — it must be read BEFORE local state is dropped and sent with the request.
  const token = getToken();
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  // Cookies are now set without a domain attribute (see authController.js),
  // so clearing must not specify one either — a mismatched domain silently
  // fails to delete the cookie.
  document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  document.cookie = 'user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

  const baseURL = process.env.NODE_ENV === 'production'
    ? 'https://api.zaptude.com/api'
    : 'http://localhost:5000/api';
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  // keepalive lets the request finish even when the page navigates straight to /login.
  fetch(`${baseURL}/auth/logout`, { method: 'POST', credentials: 'include', headers, keepalive: true }).catch(() => {});
};
